import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core';
import {
  displayErrorMessage,
  displaySuccess,
} from 'Helpers/FacetNotificationManager';
import { useLocation } from 'react-router';
import useSimpleHousehold from 'Hooks/useSimpleHousehold';
import useCollection from 'Hooks/useCollection';
import relationships from 'Consts/Relationships';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import classNames from 'classnames';
import ActionItems from 'Components/UI/ActionItems';
import EmergencyFund from 'Components/UI/EmergencyFund';
import GoalCardList from './GoalCardList';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    flex: '1 1',
    flexWrap: 'wrap',
    gap: `${theme.spacing(2)}px`,
  },
  section: {
    display: 'flex',
    flexDirection: 'column',
    margin: theme.spacing(1),
    padding: theme.spacing(2),
  },
  header: {
    color: theme.palette.facet.primaryBlue,
    marginBottom: theme.spacing(4),
    textAlign: 'center',
  },
  emergencyFundCard: {
    margin: theme.spacing(1),
    padding: theme.spacing(2),
    width: '100%',
  },
}));

const GoalsAndObjectives = ({ className, elevation }) => {
  const { householdResource } = useSimpleHousehold();
  const { collection, setCollection } = useCollection();
  const classes = useStyles();
  const location = useLocation();

  useEffect(() => {
    if (
      householdResource
      && householdResource.relationship(relationships.goals)
      && householdResource.relationship(relationships.goals).link('related')
    ) {
      householdResource
        .relationship(relationships.goals)
        .link('related')
        .Get()
        .then((coll) => {
          setCollection(coll);
        })
        .catch((err) => {
          displayErrorMessage(err, err.errors);
        });
    }
  }, [householdResource, location]);

  const handleDelete = (goalResource) => {
    goalResource
      .link('self')
      .Delete()
      .then(() => collection.refresh())
      .then(coll => setCollection(coll))
      .then(() => displaySuccess('Successfully deleted goal'))
      .catch((e) => {
        displayErrorMessage(e, 'Failed to delete goal');
      });
  };

  return (
    <div
      className={classNames(classes.root, className)}
      test={'snapshot-goals-and-objectives'}
    >
      <Paper elevation={elevation} className={classes.emergencyFundCard}>
        <EmergencyFund />
      </Paper>
      <Paper elevation={2} className={classNames(classes.card, classes.section)}>
        <Typography className={classes.header} variant="h2">
            Goals & Objectives
        </Typography>
        <div className="content">
          <GoalCardList loadedGoals={collection} onDelete={handleDelete} />
        </div>
      </Paper>
      <Paper elevation={2} className={classes.section}>
        <Typography className={classes.header} variant="h2">
            Action Items
        </Typography>
        <ActionItems showDivider />
      </Paper>
    </div>
  );
};

export default GoalsAndObjectives;

GoalsAndObjectives.defaultProps = {
  className: '',
  elevation: 2,
};

GoalsAndObjectives.propTypes = {
  className: PropTypes.string,
  elevation: PropTypes.number,
};
